export default "__VITE_ASSET__S2L89VDB__"